/**
 * <random-promo>
 * Picks one of its child <template> entries at random on each page load and
 * clones it into the DOM. Used by the "Signature Product Features" collection
 * block to rotate through Featured Promo Banners metaobject entries.
 *
 * Templates are inert, so only the chosen entry's image/video is downloaded.
 */
class RandomPromo extends HTMLElement {
  connectedCallback() {
    if (this.dataset.rendered === 'true') return;

    const templates = this.querySelectorAll(':scope > template');
    if (!templates.length) return;

    const chosen = templates[Math.floor(Math.random() * templates.length)];
    const fragment = chosen.content.cloneNode(true);

    templates.forEach((template) => template.remove());
    this.appendChild(fragment);
    this.dataset.rendered = 'true';
  }
}

if (!customElements.get('random-promo')) {
  customElements.define('random-promo', RandomPromo);
}
